import { NativeModules, Platform } from 'react-native';

const LINKING_ERROR =
  `The package 'react-native-zoi-local-authentication' doesn't seem to be linked. Make sure: \n\n` +
  Platform.select({ ios: "- You have run 'pod install'\n", default: '' }) +
  '- You rebuilt the app after installing the package\n' +
  '- You are not using Expo managed workflow\n';

const ZoiLocalAuthentication = NativeModules.ZoiLocalAuthentication
  ? NativeModules.ZoiLocalAuthentication
  : new Proxy(
      {},
      {
        get() {
          throw new Error(LINKING_ERROR);
        },
      }
    );


export default function Unlock(a: string, b: string): Promise<Object> {
  return ZoiLocalAuthentication.unlock(a, b);
}


